var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowCustomMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#5F11EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7102_1900",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7102_1900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 33.8887V31.1112H50V33.8887H35ZM35 38.8887V36.1112H50V38.8887H35ZM40.5554 56.6667H29.5833C28.3103 56.6667 27.2281 56.2211 26.3367 55.33C25.4456 54.4386 25 53.3564 25 52.0833V46.6667H30V23.3333H55V38.9304C54.5369 38.8749 54.0682 38.8815 53.5938 38.9504C53.1193 39.0193 52.6621 39.1424 52.2221 39.3196V26.1112H32.7779V46.6667H44.2221L41.4446 49.4446H27.7779V52.0833C27.7779 52.595 27.9515 53.0239 28.2988 53.37C28.646 53.7158 29.0649 53.8888 29.5554 53.8888H40.5554V56.6667ZM43.3333 56.6667V51.5417L52.5417 42.375C52.7917 42.125 53.0694 41.9444 53.375 41.8333C53.6806 41.7222 53.9861 41.6667 54.2917 41.6667C54.625 41.6667 54.9444 41.7292 55.25 41.8542C55.5556 41.9792 55.8333 42.1667 56.0833 42.4167L57.625 43.9583C57.8658 44.2083 58.044 44.4861 58.1596 44.7917C58.2754 45.0972 58.3333 45.4028 58.3333 45.7083C58.3333 46.0139 58.2732 46.3264 58.1529 46.6458C58.0324 46.9653 57.8479 47.25 57.5996 47.5L48.4583 56.6667H43.3333ZM45.8333 54.1667H47.4167L52.4583 49.0833L51.7083 48.2917L50.9167 47.5417L45.8333 52.5833V54.1667ZM51.7083 48.2917L50.9167 47.5417L52.4583 49.0833L51.7083 48.2917Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowCustomMessages);
export default __webpack_public_path__ + "static/media/icon-flow-custom-messages.ebe87aec317884b52e9f39e444c5f911.svg";
export { ForwardRef as ReactComponent };